import { atom } from "recoil";

export const mainDialogState = atom<boolean>({
  key: "mainDialogState",
  default: false,
});
